'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Fab = Fab;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fab = require('@material-ui/core/Fab');

var _Fab2 = _interopRequireDefault(_Fab);

var _styles = require('@material-ui/core/styles');

var _Add = require('@material-ui/icons/Add');

var _Add2 = _interopRequireDefault(_Add);

var _Typography = require('../Typography');

var _fab = require('../../schema/component/fab.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var useStyles = (0, _styles.makeStyles)({
  container: {
    background: function background(_ref) {
      var _background = _ref.background;
      return _background;
    },
    borderRadius: function borderRadius(_ref2) {
      var _borderRadius = _ref2.borderRadius;
      return _borderRadius;
    },
    boxShadow: 'none',
    height: function height(_ref3) {
      var _height = _ref3.height;
      return _height;
    },
    minHeight: function minHeight(_ref4) {
      var height = _ref4.height;
      return height;
    },
    padding: function padding(_ref5) {
      var _padding = _ref5.padding;
      return _padding;
    },
    width: function width(_ref6) {
      var _width = _ref6.width;
      return _width;
    },
    '&:hover, &:active': {
      background: function background(_ref7) {
        var _background2 = _ref7.background;
        return _background2;
      },
      boxShadow: 'none'
    }
  },
  icon: {
    color: function color(_ref8) {
      var _color = _ref8.color;
      return _color;
    },
    fontSize: function fontSize(_ref9) {
      var iconSize = _ref9.iconSize;
      return iconSize;
    }
  },
  label: {
    color: function color(_ref10) {
      var _color2 = _ref10.color;
      return _color2;
    },
    marginLeft: '12px',
    textTransform: 'capitalize'
  },
  children: {
    color: function color(_ref11) {
      var _color3 = _ref11.color;
      return _color3;
    },
    '& > *': {
      color: function color(_ref12) {
        var _color4 = _ref12.color;
        return _color4;
      }
    },
    '& svg': {
      fontSize: function fontSize(_ref13) {
        var iconSize = _ref13.iconSize;
        return iconSize;
      },
      marginTop: '5.5px'
    }
  }
});

function Fab(_ref14) {
  var children = _ref14.children,
      className = _ref14.className,
      Icon = _ref14.Icon,
      label = _ref14.label,
      labelVariant = _ref14.labelVariant,
      variant = _ref14.variant,
      props = _objectWithoutProperties(_ref14, ['children', 'className', 'Icon', 'label', 'labelVariant', 'variant']);

  var variantSelected = _fab.properties[variant] && _fab.properties[variant].properties || _fab.properties.primary.properties;

  var classess = useStyles(_extends({}, variantSelected));

  return _react2.default.createElement(
    _Fab2.default,
    _extends({
      className: 'fab ' + classess.container + ' ' + className,
      disableRipple: variantSelected.isChildren
    }, props),
    !variantSelected.isChildren && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(Icon, { className: 'fab-icon ' + classess.icon }),
      variantSelected.isLabel && _react2.default.createElement(
        _Typography.Typography,
        {
          variant: labelVariant,
          className: 'fab-label ' + classess.label
        },
        label
      )
    ),
    variantSelected.isChildren && _react2.default.createElement(
      'div',
      { className: 'fab-child ' + classess.children },
      children
    )
  );
}

Fab.defaultProps = {
  children: null,
  className: null,
  Icon: _Add2.default,
  label: 'Create',
  labelVariant: 'textbutton',
  variant: 'primary'
};

Fab.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.node]),
  className: _propTypes2.default.string,
  Icon: _propTypes2.default.shape({}),
  label: _propTypes2.default.string,
  labelVariant: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

exports.default = Fab;